<template>
  <v-container>
    <v-select
      :items="themes"
      v-model="currentTheme"
      item-text="name"
      item-value="id"
      solo
      background-color="transparent"
      flat
      class="display-2 text-xs-center"
      @change="goToTheme"
      style="color: #000 !important;"
    >
      <template v-slot:selection="{ item }">
        <span class="d-flex justify-center" style="width: 100%;">
          {{ item.name }}
        </span>
      </template>
    </v-select>
<!--    <h2 class="display-2 text-xs-center">{{ themeHeader }}</h2>-->

    <v-layout style="margin-top: 1px;background: #fff;border: 1px solid #ddd;padding-left: 20px; padding-right: 20px;margin-left: 0px;margin-right:0px;" align-start justify-center row dashBoardHeader>
      <view-selector
          class="mt-3"
          v-on:view-changed="viewChanged"
          v-if="themeHeader !== 'Dashboard'"
          :bus="bus"
      ></view-selector>
      <v-spacer></v-spacer>
      <date-range-selector v-if="enableDateSelector === true" v-model="dateRange" :date-range="dateRange" v-on:dates-picked="submitDates" :bus="bus"></date-range-selector>
      <v-spacer v-if="enableDateSelector === true"></v-spacer>
      <period-selector
          class="mt-3"
          v-on:period-changed="$emit('date-range-changed')"
          v-if="viewType === 'date_range' && (themeHeader === 'Conversion' || themeHeader === 'Escalation')"
      ></period-selector>
      <interval-selector
        class="mt-3"
        v-on:period-changed="$emit('date-range-changed')"
        v-if="viewType === 'date_range' && themeHeader === 'Fulfillment'"
      ></interval-selector>
    </v-layout>
  </v-container>
</template>

<script>
import DateRangeSelector from "./DateRangeSelector";
import ViewSelector from "./ViewSelector";
import PeriodSelector from "./PeriodSelector";
import moment from 'moment';
import IntervalSelector from "./IntervalSelector";
import {mapGetters} from "vuex";
import {theme} from "../../../store/modules/dashboard/getters";

export default {
  name: "DashHeader",
  components: {
    IntervalSelector,
    DateRangeSelector,
    ViewSelector,
    PeriodSelector
  },
  data() {
    return {
      currentTheme: 'conversion',
      dateRange: {
        to: '',
        from: ''
      },
      viewType: '',
    };
  },
  props: {
    themeHeader: {
      type: String,
      default: 'Dashboard'
    },
    enableDateSelector: {
      type: Boolean,
      default: true
    },
    bus: {
      type: Object
    },
  },
  created() {
    switch (this.currentTheme) {
      case 'conversion':
        this.dateRange.from = moment().subtract(3, 'months').format('YYYY-MM-DD');
        break;
      case 'fulfillment':
        this.dateRange.from = moment().subtract(1, 'months').format('YYYY-MM-DD');
        break;
    }
    this.dateRange.to = moment().format('YYYY-MM-DD');

    if (this.$store.state.Dashboard.widgetConfig.dateRange.to.length > 0) {
      this.dateRange.to = this.$store.state.Dashboard.widgetConfig.dateRange.to;
    } else {
      this.$store.state.Dashboard.widgetConfig.dateRange.to = this.dateRange.to;
    }

    if (this.$store.state.Dashboard.widgetConfig.dateRange.from.length > 0) {
      this.dateRange.from = this.$store.state.Dashboard.widgetConfig.dateRange.from;
    } else {
      this.$store.state.Dashboard.widgetConfig.dateRange.from = this.dateRange.from;
    }

    this.viewType = this.$store.state.Dashboard.widgetConfig.viewType;

    this.currentTheme = this.$route.path.replace('/dashboard/', '');
  },
  methods: {
    updateDateRange(payload) {
      this.updateDateRangeFrom(payload.from);
      this.updateDateRangeTo(payload.to);
    },
    submitDates(payload) {
      this.updateDateRange(payload);

      this.$emit('date-range-changed', payload);
    },
    updateDateRangeFrom(payload, val) {
      this.dateRange.from = payload;
      this.$store.commit('setDateRangeFrom', this.dateRange.from);
    },
    updateDateRangeTo(payload, val) {
      this.dateRange.to = payload;
      this.$store.commit('setDateRangeTo', this.dateRange.to);
    },
    viewChanged(payload) {
      this.viewType = payload;
      this.$emit('range-config-updated', payload);
    },
    goToTheme(slug) {
      const dateRange = {
        to: moment().format('YYYY-MM-DD'),
        from: moment().subtract(3, 'months').format('YYYY-MM-DD')
      }
      switch (slug) {
        case 'conversion':
          dateRange.from = moment().subtract(3, 'months').format('YYYY-MM-DD');
          break;
        case 'fulfillment':
          dateRange.from = moment().subtract(1, 'months').format('YYYY-MM-DD');
          break;
      }
      this.updateDateRange(dateRange);
      this.$store.commit('setTheme', slug);
      if (typeof this.bus === "object") {
        this.bus.$emit('trigger-theme-changed', slug);
      }
      this.$router.push('/dashboard/' + slug);
    }
  },
  computed: {
    ...mapGetters([
      'objAuthorize'
    ]),
    userIsAdmin() {
      return this.objAuthorize.email === "bwsuperuser@ndtec.co.za" || this.objAuthorize.email === "rudolf.jvrensburg@builders.co.za";
    },
    themes() {
      const themes = [
        {
          name: 'Conversion (without Prior Year)',
          id: 'conversion'
        },
        {
          name: 'Conversions (with Prior Year)',
          id: 'conversion-py',
        },
        {
          name: 'Escalations',
          id: 'escalation',
        }
      ]

      return themes;
    }
  }
}
</script>

<style scoped>

</style>
